import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Promotion/api/PublicDiscountCodesQuery").then(r => {
        commit("setList", r.data.data);
      });
    },
    create({ commit, dispatch }, model) {
      return ajax
        .post("Promotion/api/PublicDiscountCodes", model)
        .then(r => {});
    },
    fetchSearch({ commit, dispatch }, name) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Promotion/api/PromotionProducts/productInfo?" + name)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
